import React, { useEffect } from 'react';

import { useGraphQLSuspenseQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { useNavigate } from 'react-router-dom';

import { getPlatformFeePaidBy } from './data';
import FlowController from './FlowController';
import { EditBillingPlanFlowDocument } from './graphql/query.editBillingPlanFlow.generated';
import { useBillingPlanStorage } from './hooks/useBillingPlansStorage';
import { deconstructBillingRate } from './utils';

import urlBuilder from '../../../Shared/url-builder';
import { FullPageLoader } from '../../FullPageLoader';

const EditBillingPlanFlow: React.FC = () => {
  const exitToPath = '/client_billing/billing_plans';
  const navigate = useNavigate();
  const billingPlanId = useRequiredParam('billingPlanId');
  const { data } = useGraphQLSuspenseQuery(EditBillingPlanFlowDocument, { variables: { id: billingPlanId } });
  const { firm } = data;
  const { billingPlan } = firm;

  const paidBy = () => {
    return billingPlan?.platformFeeAllocation ? getPlatformFeePaidBy(billingPlan?.platformFeeAllocation) : null;
  };

  const clientPortion = () => {
    if (billingPlan?.platformFeeAllocation.__typename === 'SharedPlatformFeeAllocation') {
      return `${billingPlan?.platformFeeAllocation.clientPortion}`;
    }
    return '0';
  };

  const billingPlanValues = {
    // @ts-expect-error TS18049 violates strict null checks
    billingPlanId: billingPlan.id,
    // @ts-expect-error TS18049 violates strict null checks
    planName: billingPlan.name,
    // @ts-expect-error TS18049 violates strict null checks
    configurationType: billingPlan.billingRate.__typename,
    // @ts-expect-error TS18049 violates strict null checks
    paymentType: billingPlan.paymentType,
    feeConfiguration: firm.feeConfiguration,
    billingFrequency: firm.billingFrequency,
    platformFee: firm.platformFee,
    platformFeePaidBy: paidBy(),
    sharedPlatformFeeClientPortionBps: clientPortion(),
    // @ts-expect-error TS18049 violates strict null checks
    numberOfClients: billingPlan.numberOfClients,
    exitToPath,
    title: 'Edit Billing Plan | 1 of 2',
    // @ts-expect-error TS18049 violates strict null checks
    ...deconstructBillingRate(billingPlan.billingRate),
  };

  // @ts-expect-error TS2345 violates strict null checks
  const { values: sessionValues } = useBillingPlanStorage(billingPlanValues);

  useEffect(() => {
    if (!sessionValues) {
      // If sessionValues are not set, redirect to the home page
      void navigate('/client_billing/billing_plans');
    }
  }, [sessionValues, navigate]);

  if (!sessionValues) {
    return null;
  }

  return (
    <FlowController url={`${urlBuilder.getEditBillingPlanFlowRoute.absolutePath}/*`} initialValues={sessionValues} />
  );
};

export const EditBillingPlanFlowPage: React.FC = () => {
  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <EditBillingPlanFlow />
    </React.Suspense>
  );
};
